import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'berry-image',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './image.component.html',
    styleUrl: './image.component.scss'
})

export class ImageComponent {

    @Input('src') src: string = '';
    @Input('isBase64') isBase64: boolean = false;
    @Input('class') class: string = '';
    @Input('size') size: string | number = '';
   
}

